import { Card, CardContent } from "@devhop/ui";
import {
  RiLiveLine,
  RiMoneyDollarCircleLine,
  RiShoppingBag3Line,
  RiTimeLine,
} from "@remixicon/react";
import { formatKip } from "@/modules/cf-feed/presentation/ui/table-helpers";
import type { CfDashboardKpis } from "../api/types";

type KpiCardsProps = {
  data?: CfDashboardKpis;
  isLoading: boolean;
};

type KpiItem = {
  label: string;
  value: string;
  icon: React.ElementType;
};

export function KpiCards({ data, isLoading }: KpiCardsProps) {
  const items: KpiItem[] = [
    {
      label: "ຈຳນວນອໍເດີ (ຊ່ວງທີ່ເລືອກ)",
      value: data ? String(data.ordersInRange) : "-",
      icon: RiShoppingBag3Line,
    },
    {
      label: "ຍອດຂາຍ (ຊ່ວງທີ່ເລືອກ)",
      value: data ? formatKip(data.revenueInRange) : "-",
      icon: RiMoneyDollarCircleLine,
    },
    {
      label: "ຍອດຂາຍລວມທັງໝົດ",
      value: data ? formatKip(data.revenueTotal) : "-",
      icon: RiMoneyDollarCircleLine,
    },
    {
      label: "ຮອບຂາຍທີ່ກຳລັງເປີດ",
      value: data ? String(data.activeSessions) : "-",
      icon: RiLiveLine,
    },
    {
      label: "ອໍເດີລໍຖ້າຢືນຢັນ",
      value: data ? String(data.pendingOrders) : "-",
      icon: RiTimeLine,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
      {items.map((item) => (
        <Card key={item.label}>
          <CardContent className="flex flex-col gap-1 p-4">
            <span className="inline-flex items-center gap-2 text-muted-foreground text-xs">
              <item.icon className="size-4" />
              {item.label}
            </span>
            <span className="font-bold text-xl tracking-tight">
              {isLoading && !data ? (
                <span className="inline-block h-6 w-16 animate-pulse rounded bg-muted" />
              ) : (
                item.value
              )}
            </span>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
